module.exports = __webpack_public_path__ + "img/pick5.f78cc43b.png";